export default __webpack_public_path__ + "static/media/Venturer's Helm of Crouching Calm.d478afb8.jpg";